export default "__VITE_ASSET__4dc29ae0__"